import * as THREE from 'three';
export const physicalObjects = ['Marble', 'Upstairs'];
export const portraitNames = [
    {
        slug: 'Girls_Cutting_Hair-Artwork',
        name: 'SPIRIT',
        artDescription: `
      <p>
      Konsep yang usung pada desain kali ini yaitu representasi dari sebuah
gairah pada gelaran akbar piala dunia yang tepat pada tahun 2022,
dengan menarik benang merah “ young and modern” pada gelaran akbar
piala dunia tak lepas dari gairah anak muda dan sepakbola modern yang
sering kita liat disetiap stadion sepakbola, baik diluar maupun didalam
stadion, tidak bisa dibayangkan jika satu stadion dengan gairah disetiap
pemain dan supporter saling beriringan menjadi sebuah atmosfer yang
sangat indah disetiap gelaranya yang akan terus menyala selama gelaran
piala dunia berlangsung.</p>
    `,
        label: 'Prototype-Sign018',
        artist: 'IKIW',
        description: `
<p>Rifky Nugraha biasa dipanggil IKIW, berasal dari kabupaten
Kuningan tepatnya di provinsi Jawa Barat, anak kedua dari tiga
bersaudara.</p>
<p>Sebelum terjun kedunia desain, IKIW mengawali hobi dari
menggambar sejak taman kanak-kanak, dan terus menggemari
gambar hingga ke bangku sekolah menengah ke atas dan dilanjut
dengan mengambil jurusan Pendidikan Seni Rupa. Ikiw sudah
mendalami dunia ilustrasi selama 4 tahun dan diterapkan pada
desain-desainnya sampai dengan hari ini.</p>

    `,
        instagram: 'https://www.instagram.com/rifkyikiw',
        coordinates: new THREE.Vector3(-17, 0.2, -2.5)
    },
    {
        slug: 'Two_Women_on_a_field-Artwork',
        name: 'SPIRIT',
        artDescription: `
    <p>Konsep yang usung pada desain kali ini yaitu representasi dari sebuah
gairah pada gelaran akbar piala dunia yang tepat pada tahun 2022,
dengan menarik benang merah “ young and modern” pada gelaran akbar
piala dunia tak lepas dari gairah anak muda dan sepakbola modern yang
sering kita liat disetiap stadion sepakbola, baik diluar maupun didalam
stadion, tidak bisa dibayangkan jika satu stadion dengan gairah disetiap
pemain dan supporter saling beriringan menjadi sebuah atmosfer yang
sangat indah disetiap gelaranya yang akan terus menyala selama gelaran
piala dunia berlangsung.</p>
    `,
        label: 'Prototype-Sign008',
        artist: 'IKIW',
        description: `
<p>Rifky Nugraha biasa dipanggil IKIW, berasal dari kabupaten
Kuningan tepatnya di provinsi Jawa Barat, anak kedua dari tiga
bersaudara.</p>
<p>Sebelum terjun kedunia desain, IKIW mengawali hobi dari
menggambar sejak taman kanak-kanak, dan terus menggemari
gambar hingga ke bangku sekolah menengah ke atas dan dilanjut
dengan mengambil jurusan Pendidikan Seni Rupa. Ikiw sudah
mendalami dunia ilustrasi selama 4 tahun dan diterapkan pada
desain-desainnya sampai dengan hari ini.</p>
    `,
        instagram: 'https://www.instagram.com/rifkyikiw',
        coordinates: new THREE.Vector3(-17, 0.2, -7.5)
    },
    {
        slug: 'No_Words-Artwork',
        name: 'Part Of The Goal',
        label: 'Prototype-Sign014',
        artist: 'wacky',
        description: `
Wacky started career since 2006 as a street artist and graphic designer based on Indonesia. 
Expert at colour pattern, realist-naturalist illustration, and character with synthwave style. 
Mostly the artwork collaboration are tees merchandise, digital painting, artwork on various surfaces 
such us wall, canvas, wooden-board or skateboard. 
Wacky also participated in many exhibition such as 
POP CON ASIA, Soundrenaline, Street Dealin by Gardu House, and many more.
    `,
        instagram: 'https://www.instagram.com/wacky.ok',
        coordinates: new THREE.Vector3(-17, 0.2, 2.8)
    },
    {
        slug: 'Red_Vase_On_A_Table-Artwork',
        name: 'Calsio',
        label: 'Prototype-Sign012',
        artist: 'wacky',
        description: `
Wacky started career since 2006 as a street artist and graphic designer based on Indonesia. 
Expert at colour pattern, realist-naturalist illustration, and character with synthwave style. 
Mostly the artwork collaboration are tees merchandise, digital painting, artwork on various surfaces 
such us wall, canvas, wooden-board or skateboard. 
Wacky also participated in many exhibition such as 
POP CON ASIA, Soundrenaline, Street Dealin by Gardu House, and many more.
    `,
        instagram: 'https://www.instagram.com/wacky.ok',
        coordinates: new THREE.Vector3(-17, 0.2, 7.8)
    },
    {
        slug: 'Person_Holding_Plate-Artwork002',
        name: 'Limitless',
        label: 'Prototype-Sign015',
        artist: 'salmicas',
        description: `
Labib A Falahi or better known as Salmicas, is a graffiti artist from Solo, Central Java, Indonesia. 
He had a tertiary education at Sebelas Maret University, Surakarta, and graduated with a major in Visual Communication Design.
His interest in visual art, especially graffiti, started in 2010, when he was in high school. In his journey, Salmicas has experienced several stylistic
changes in his work. One of them, he had used Dark Art as a drawing style, before he found a style that really represented him, he called it the Graffiti
Pattern Style.
    `,
        instagram: 'https://www.instagram.com/salmicas_',
        coordinates: new THREE.Vector3(-0.7, 0.2, 7.4)
    },
    {
        slug: 'Person_Holding_Plate-Artwork001',
        name: 'Limitless',
        label: 'Prototype-Sign004',
        artist: 'salmicas',
        description: `
Labib A Falahi or better known as Salmicas, is a graffiti artist from Solo, Central Java, Indonesia. 
He had a tertiary education at Sebelas Maret University, Surakarta, and graduated with a major in Visual Communication Design.
His interest in visual art, especially graffiti, started in 2010, when he was in high school. In his journey, Salmicas has experienced several stylistic
changes in his work. One of them, he had used Dark Art as a drawing style, before he found a style that really represented him, he called it the Graffiti
Pattern Style.
    `,
        instagram: 'https://www.instagram.com/salmicas_',
        coordinates: new THREE.Vector3(-6, 0.2, 7.4)
    },
    {
        slug: 'People_Puzzle-Artwork001',
        name: 'Limitless',
        label: 'Prototype-Sign005',
        artist: 'salmicas',
        description: `
Labib A Falahi or better known as Salmicas, is a graffiti artist from Solo, Central Java, Indonesia. 
He had a tertiary education at Sebelas Maret University, Surakarta, and graduated with a major in Visual Communication Design.
His interest in visual art, especially graffiti, started in 2010, when he was in high school. In his journey, Salmicas has experienced several stylistic
changes in his work. One of them, he had used Dark Art as a drawing style, before he found a style that really represented him, he called it the Graffiti
Pattern Style.
    `,
        instagram: 'https://www.instagram.com/salmicas_',
        coordinates: new THREE.Vector3(-10, 0.2, 7.4)
    },
    {
        slug: 'Two_Girls_on_Tiles-Artwork',
        name: 'High & Hopes',
        label: 'Two_Girls_on_Tiles-Sign',
        artist: 'Herzven',
        description: `
Herzven or Herz for short. Born July 7th 1993 is a Jakarta bred artist
on the rise shaking the art scene up on a national and global scale.
He has been making rifts in the field of illustration & street art.
Vibrant color, visuals about animals, mythological elements and
these elements form some of Herzven characteristics in creating.
Some of his works on various brands and media have been done,
Skateboard Nusantara (Exhibition on Gallery Nasional Indonesia),
Winner of Secret Walls of Jakarta & Jakarta vs Hongkong, Illustration
for the Collaboration album of SlumpGod x Wifisfuneral x 458Keez,
Contribute Artwork Jake Phelps for Thrasher Magazine, Best Content
Creator from KEMINFO, Runner Up SuperArtFest, and many more.
    `,
        instagram: 'https://www.instagram.com/herzven',
        coordinates: new THREE.Vector3(-7, 0.2, -7.5)
    },
    {
        slug: 'What_Is_Real_Anyway-Artwork',
        name: 'Unity',
        label: 'What_Is_Real_Anyway-Sign',
        artist: 'Herzven',
        description: `
Herzven or Herz for short. Born July 7th 1993 is a Jakarta bred artist
on the rise shaking the art scene up on a national and global scale.
He has been making rifts in the field of illustration & street art.
Vibrant color, visuals about animals, mythological elements and
these elements form some of Herzven characteristics in creating.
Some of his works on various brands and media have been done,
Skateboard Nusantara (Exhibition on Gallery Nasional Indonesia),
Winner of Secret Walls of Jakarta & Jakarta vs Hongkong, Illustration
for the Collaboration album of SlumpGod x Wifisfuneral x 458Keez,
Contribute Artwork Jake Phelps for Thrasher Magazine, Best Content
Creator from KEMINFO, Runner Up SuperArtFest, and many more.
    `,
        instagram: 'https://www.instagram.com/herzven',
        coordinates: new THREE.Vector3(-3, 0.2, -7.5)
    },
    {
        slug: 'Woman_at_a_pool-Artwork',
        name: 'Goal',
        label: 'Prototype-Sign001',
        artist: 'Harizhazka',
        description: `
Harizhazka is an artist who mainly works with drawing and mixed media. Having
graduated from an interior architect school at Universitas Indonesia, Harizhazka
exploring works with the architectural approach by combining geometric shapes, lines,
colours and taking daily life as subject matter.
    `,
        instagram: 'https://www.instagram.com/harishazka',
        coordinates: new THREE.Vector3(1.2, 0.2, -7.5)
    },
    {
        slug: 'UnrecognisableFigure-Artwork',
        name: 'Warzone',
        label: 'Prototype-Sign002',
        artist: 'Harizhazka',
        description: `
Harizhazka is an artist who mainly works with drawing and mixed media. Having
graduated from an interior architect school at Universitas Indonesia, Harizhazka
exploring works with the architectural approach by combining geometric shapes, lines,
colours and taking daily life as subject matter.
    `,
        instagram: 'https://www.instagram.com/harishazka',
        coordinates: new THREE.Vector3(5.5, 0.2, -7.5)
    },
    {
        slug: 'Too_Loud-Artwork',
        name: 'Feast',
        label: 'Prototype-Sign007',
        artist: 'SICOVECAS',
        description: `
SICOVECAS is a Yogyakartan mural and graffiti
artist who found his identity as ‘As I See’ (SIC)
in 2006. His pieces play with elements of water,
jugs and wild plants, representing his experience
of growing up in Jogja -- a city known for being
colourful and full of overlap but somehow still in
harmony. His characteristic abstract patterns reflect
the movement and the energy of his hometown.
    `,
        instagram: 'https://www.instagram.com/sicovecas',
        coordinates: new THREE.Vector3(10.5, 0.2, -7.5)
    },
    {
        slug: 'Heated_2020-Artwork001',
        name: 'Harmony Of Energy',
        label: 'Prototype-Sign006',
        artist: 'Fivust',
        description: `
Integrating his signature style of explosive color tone and mood, 
Fivust has developed a distinct style that carries a fun element of surprise everywhere. 
Whether on the streets, in galleries, and many more.

Fivust admires the spectrum of possibility and flexibility of a human 
alter ego in creating his works. For him, it is fascinating that each 
of them has their own alter ego that can be expressed in so many ways. 
It develops into something that has grown together with them from time to time. 
    `,
        instagram: 'https://www.instagram.com/fivust',
        coordinates: new THREE.Vector3(10.5, 0.2, -4.2)
    },
    {
        slug: 'Heated_2020-Artwork002',
        name: 'Harmony Of Energy',
        label: 'Prototype-Sign003',
        artist: 'Fivust',
        description: `
Integrating his signature style of explosive color tone and mood, 
Fivust has developed a distinct style that carries a fun element of surprise everywhere. 
Whether on the streets, in galleries, and many more.

Fivust admires the spectrum of possibility and flexibility of a human 
alter ego in creating his works. For him, it is fascinating that each 
of them has their own alter ego that can be expressed in so many ways. 
It develops into something that has grown together with them from time to time. 
    `,
        instagram: 'https://www.instagram.com/fivust',
        coordinates: new THREE.Vector3(10.5, 0.2, 0.2)
    },
    {
        slug: 'Person_Holding_Plate-Artwork',
        name: 'Sadulur Tunggal Tembok',
        label: 'Prototype-Sign025',
        artist: 'MbutGambutz',
        description: `
Guruh Indra Waskita or Gambutz is a Mural artist, Freelancer Illustrator, Art Decorator from
Kudus, West Java. He has involved in many exhibition also project regarding mural and illustration.
    `,
        instagram: 'https://www.instagram.com/mbutzgambutz',
        coordinates: new THREE.Vector3(8.3, 4.2, -7.6)
    },
    {
        slug: 'Person_Leaning_Against_a_Chair-Artwork',
        name: 'The Dream',
        label: 'Prototype-Sign024',
        artist: 'cloze',
        description: `
Been doing graffiti since highschool, CLOZE started his
career as a graffiti writer at Gardu House. CLOZE has
now opened his own graffiti store named CZPlaystore.
With his college friends as partners, he develops his
playground by opening another business called
CZmocktail Bar.

CLOZE is known for his wild style of funky-fresh colors and
his bold, big piece for quickie. Dedicated to make the
graffiti scene bigger, he regularly hosts collaborations
events with other artists and communities such as
HipHop and Skateboard.
    `,
        instagram: 'https://www.instagram.com/sikcloze',
        coordinates: new THREE.Vector3(11.6, 4.2, -7.6)
    },
    {
        slug: 'Person_Leaning_Against_a_Chair-Artwork001',
        name: 'The Dream',
        label: 'Prototype-Sign023',
        artist: 'cloze',
        description: `
Been doing graffiti since highschool, CLOZE started his
career as a graffiti writer at Gardu House. CLOZE has
now opened his own graffiti store named CZPlaystore.
With his college friends as partners, he develops his
playground by opening another business called
CZmocktail Bar.

CLOZE is known for his wild style of funky-fresh colors and
his bold, big piece for quickie. Dedicated to make the
graffiti scene bigger, he regularly hosts collaborations
events with other artists and communities such as
HipHop and Skateboard.
    `,
        instagram: 'https://www.instagram.com/sikcloze',
        coordinates: new THREE.Vector3(11.6, 4.2, -4.4)
    },
    {
        slug: 'Still_Waiting-Artwork',
        name: 'Fairplay',
        label: 'Prototype-Sign022',
        artist: 'Arief Hardinata',
        description: `
Arief Hadinata is a Mural Artist and Illustrator from Central Java, Indonesia.

Started working in illustration since 2006 and trying to enjoy making
a Mural and design in 2008. I am an Expert on Visual Arts and all
Illustration for Mural or product design. I make it by manual or digital
painting. Until now, I am still active in making some art projects from
cross-discipline, collaborative art, workshop, exhibition, and other
good arts.
    `,
        instagram: 'https://www.instagram.com/hokgstudio',
        coordinates: new THREE.Vector3(11.6, 4.2, 0.4)
    },
    {
        slug: 'Maxim-Artwork',
        name: 'Euphoria',
        label: 'Prototype-Sign021',
        artist: 'Arief Hardinata',
        description: `
Arief Hadinata is a Mural Artist and Illustrator from Central Java, Indonesia.

Started working in illustration since 2006 and trying to enjoy making
a Mural and design in 2008. I am an Expert on Visual Arts and all
Illustration for Mural or product design. I make it by manual or digital
painting. Until now, I am still active in making some art projects from
cross-discipline, collaborative art, workshop, exhibition, and other
good arts.
    `,
        instagram: 'https://www.instagram.com/hokgstudio',
        coordinates: new THREE.Vector3(11.6, 4.2, 4.4)
    },
    {
        slug: 'Maxim-Artwork001',
        name: 'The Champion',
        label: 'Prototype-Sign020',
        artist: 'Arief Hardinata',
        description: `
Arief Hadinata is a Mural Artist and Illustrator from Central Java, Indonesia.

Started working in illustration since 2006 and trying to enjoy making
a Mural and design in 2008. I am an Expert on Visual Arts and all
Illustration for Mural or product design. I make it by manual or digital
painting. Until now, I am still active in making some art projects from
cross-discipline, collaborative art, workshop, exhibition, and other
good arts.
    `,
        instagram: 'https://www.instagram.com/hokgstudio',
        coordinates: new THREE.Vector3(11.6, 4.2, 8.4)
    },
    {
        slug: 'HiddenObject',
        name: 'Hidden Object',
        label: 'Prototype-Sign010',
        artist: 'Djarum',
        description: `
Find your experience here.
    `,
        url: 'https://djarum-gamification.pentacode.dev',
        coordinates: new THREE.Vector3(7.6, 0.2, 0.2)
    },
    {
        slug: 'ArtworkCreator',
        name: 'Artwork Creator',
        label: 'Prototype-Sign009',
        artist: 'Djarum',
        description: `
Create your own experience here!
    `,
        url: 'https://djarum-artwork.pentacode.dev/v2',
        coordinates: new THREE.Vector3(4.3, 0.2, 0.2)
    }
];
